import { ElementRef, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    appScrollElement: ElementRef<HTMLElement>;
}
